import { axiosInstance } from "../../../api/axiosInstance";
import { appCache } from "../../../cache/appCache";

// Mirrors the backend's FeeStructureDto. `fee` is the per-term fee; each of the 4 terms is charged it.
export interface FeeStructure {
  id?: number;
  gradeId: number;
  gradeName?: string;
  academicYearId?: number;
  academicYearName: string;
  fee: number;
  // True when fee dues exist for this grade and year; a change then applies only to dues created later
  hasDues?: boolean;
  // True for a CLOSED year with dues: the fee can no longer be changed
  locked?: boolean;
}

// Cached per academic year (appCache bucket "feeStructures")
export const fetchFeeStructures = (academicYearName: string): Promise<FeeStructure[]> =>
  appCache.getOrFetch(
    "feeStructures",
    () =>
      axiosInstance
        .get<FeeStructure[]>("/fee-structures", { params: { academicYear: academicYearName } })
        .then((response) => response.data),
    academicYearName
  );

// Creates or updates the fee structure for one grade + academic year
export const saveFeeStructure = async (feeStructure: FeeStructure): Promise<FeeStructure> => {
  const response = await axiosInstance.post<FeeStructure>("/fee-structures", feeStructure);
  appCache.invalidate("feeStructures", feeStructure.academicYearName);
  return response.data;
};
